export default __webpack_public_path__ + "static/media/010-orca.eee42487.svg";